import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './Tabs.scss';
var Tabs = /** @class */ (function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tabs.prototype.render = function () {
        var _a = this.props, items = _a.items, className = _a.className, onClick = _a.onClick;
        return (React.createElement("ul", { className: classnames(s['root'], className) }, items.map(function (item) { return (React.createElement("li", { key: item.index, className: classnames(s['tab-item'], item.isActive && s['active']), onClick: function () { return onClick(item.index); } },
            item.label,
            item.extras)); })));
    };
    return Tabs;
}(React.Component));
export { Tabs };
export default Tabs;
//# sourceMappingURL=Tabs.js.map